export function cloneBatchDate(value) {
    if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
        return new Date();
    }
    return new Date(value.getTime());
}

export function isSameCalendarDay(a, b) {
    if (!(a instanceof Date) || !(b instanceof Date)) {
        return false;
    }
    if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) {
        return false;
    }
    return (
        a.getFullYear() === b.getFullYear()
        && a.getMonth() === b.getMonth()
        && a.getDate() === b.getDate()
    );
}
